import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class AwinCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Urbanist', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)) {
            this.setState({ affiliateCommissionIdError: true });
        }
        console.log("in")

        let url = `/api/Merchant/GetAwinCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "awinCommissionId",
                label: "Awin Commission ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "awinApiCommissionId",
                label: "Awin API Commission ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "awinCommissionCreatedDate",
                label: "Commission Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "id",
                label: "Commission History ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "url",
                label: "URL",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserId",
                label: "Advertiser ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "publisherId",
                label: "Publisher ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "commissionSharingPublisherId",
                label: "Commission Sharing Publisher ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "commissionSharingSelectedRatePublisherId",
                label: "Commission Sharing Selected Rate Publisher ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaign",
                label: "Campaign",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "siteName",
                label: "Site Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "commissionStatus",
                label: "Commission Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "commissionAmount",
                label: "Commission Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "commissionAmountCurrency",
                label: "Commission Amount Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "saleAmount",
                label: "Sale Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "saleAmountCurrency",
                label: "Sale Amount Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "ipHash",
                label: "IP Hash",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "customerCountry",
                label: "Customer Country",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef",
                label: "Click Ref",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef2",
                label: "Click Ref 2",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef3",
                label: "Click Ref 3",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef4",
                label: "Click Ref 4",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef5",
                label: "Click Ref 5",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickRef6",
                label: "Click Ref 6",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickDate",
                label: "Click Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "transactionDate",
                label: "Transaction Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "validationDate",
                label: "Validation Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "type",
                label: "Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "declineReason",
                label: "Decline Reason",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "voucherCodeUsed",
                label: "Voucher Code Used",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "voucherCode",
                label: "Voucher Code",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "lapseTime",
                label: "Lapse Time",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "amended",
                label: "Amended",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "amendReason",
                label: "Amend Reason",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "oldSaleAmount",
                label: "Old Sale Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "oldSaleAmountCurrency",
                label: "Old Sale Amount Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "oldCommissionAmount",
                label: "Old Commission Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "oldCommissionAmountCurrency",
                label: "Old Commission Amount Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickDevice",
                label: "Click Device",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "transactionDevice",
                label: "Transaction Device",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "customerAcquisition",
                label: "Customer Acquisition",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "publisherUrl",
                label: "Publisher URL",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserCountry",
                label: "Advertiser Country",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "customParameters",
                label: "Custom Parameters",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "transactionParts",
                label: "Transaction Parts",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "paidToPublisher",
                label: "Paid To Publisher",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "paymentId",
                label: "Payment ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "transactionQueryId",
                label: "Transaction Query ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "trackedCurrencyAmount",
                label: "Tracked Currency Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "trackedCurrencyAmountCurrency",
                label: "Tracked Currency Amount Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "originalSaleAmount",
                label: "Original Sale Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "originalSaleAmountCurrency",
                label: "Original Sale Amount Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserCost",
                label: "Advertiser Cost",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "advertiserCostCurrency",
                label: "Advertiser Cost Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "basketProducts",
                label: "Basket Products",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "networkFee",
                label: "Network Fee",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "networkFeeCurrency",
                label: "Network Fee Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            }
        ];


        return (
            <div>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default AwinCommissionData;
